export enum PuzzleType {
  Regular = 'Regular',
  Arrow = 'Arrow',
}

export enum ClueType {
  Across = 'Across',
  Down = 'Down',
}

export enum AfterWordActionType {
  FirstBlankInSameWord = 'FirstBlankInSameWord',
  NextClue = 'NextClue',
}

export enum RevealType {
  Letter = 'letter',
  Word = 'word',
  Puzzle = 'puzzle',
}

export enum ArrowDirection {
  Down = 'Down',
  LeftDown = 'LeftDown',
  RightDown = 'RightDown',
  Right = 'Right',
  UpRight = 'UpRight',
  DownRight = 'DownRight',
}

export enum CellType {
  Clue = 'Clue',
  Empty = 'Empty',
  Identifier = 'Identifier',
  Regular = 'Regular',
}

export enum CellState {
  Normal = 'Normal',
  Error = 'Error',
  Correct = 'Correct',
  Revealed = 'Revealed',
}

export interface IClue {
  cells: string[];
  id: string;
  number: number;
  text: string;
  type: ClueType;
  identifier?: string;
}

export interface ICell {
  id: string;
  type: CellType;
  letter: string;
  state: CellState;
  x: number;
  y: number;
  number: number | null;
  circle: boolean;
  solution: string;
  arrow?: ICellArrowData[];
  arrowImages?: ArrowDirection[];
  identifier?: string;
}

export interface ICellArrowData {
  clueId: string;
  clueText: string;
  arrowDirection: ArrowDirection;
}

export interface IPuzzleMetaData {
  author: string;
  title: string;
  date: string;
  format: FeedFormat;
}

export interface IPuzzleData {
  type: PuzzleType;
  id: string;
  metaData: IPuzzleMetaData;
  columns: number;
  rows: number;
  clues: IClue[];
  cells: ICell[];
}

export interface IPuzzle extends IPuzzleData {
  currentCellId: string;
  currentClueId: string;
  autocheck: boolean;
  paused: boolean;
  time: number;
  wrap: boolean;
  rebus: boolean;
  fillRate: number;
  completed: boolean;
}

export enum FeedFormat {
  CN2I_HANNEQUART = "CN2I_HANNEQUART",
  GERMAN_ARROW_WORD = "GERMAN_ARROW_WORD",
  HEARST = "HEARST",
  HEARST_EUGENE_SHEFFER = "HEARST_EUGENE_SHEFFER",
  HEARST_MICRO = "HEARST_MICRO",
  LAROUSSE = "LAROUSSE",
  REACH = "REACH",
  REACH_BAUER = "REACH_BAUER",
  TCA = "TCA",
  TCA_MINI = "TCA_MINI",
}

export interface IFeedMetaData {
  id: string;
  author: string;
  date: string;
  description: string;
  format: FeedFormat;
  feedSlug: string;
  feedUrl: string;
}

export enum ArrowKeysSettings {
  Stay = 'Stay',
  Move = 'Move',
}

export enum SpacebarKeySettings {
  ClearAndMoveAhead = 'ClearAndMove',
  ToggleDirection = 'ToggleDirection',
}

export enum Provider {
  LOCALIZATION = "localization",
}

export enum CopyrightPlacement {
  WELCOME = "WELCOME",
  BOARD = "BOARD",
}
